

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 React using thie file.
 */

const colors = {
  background: {
    default: "#EEF3F9",
    paper: "#FFFFFF",
  },

  text: {
    main: "#112A52",
    focus: "#46587A",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#1565C8",
    focus: "#0E4FA3",
  },

  secondary: {
    main: "#545F71",
    focus: "#677384",
  },

  info: {
    main: "#1565C8",
    focus: "#0E4FA3",
  },

  success: {
    main: "#1F8A56",
    focus: "#2AA669",
  },

  warning: {
    main: "#E68A06",
    focus: "#FFB400",
  },

  error: {
    main: "#BA1A1A",
    focus: "#D92D20",
  },

  light: {
    main: "#F8FAFD",
    focus: "#F8FAFD",
  },

  dark: {
    main: "#0E2348",
    focus: "#193F8C",
  },

  grey: {
    100: "#FFFFFF",
    200: "#ECF1F8",
    300: "#E0E7F0",
    400: "#DFE3EC",
    500: "#C3CAD9",
    600: "#717C96",
    700: "#46587A",
    800: "#112A52",
    900: "#001B3F",
  },

  gradients: {
    primary: {
      main: "#1565C8",
      state: "#1565C8",
    },

    secondary: {
      main: "#545F71",
      state: "#677384",
    },

    info: {
      main: "#1565C8",
      state: "#1565C8",
    },

    success: {
      main: "#1F8A56",
      state: "#1F8A56",
    },

    warning: {
      main: "#FFD45C",
      state: "#E68A06",
    },

    error: {
      main: "#BA1A1A",
      state: "#BA1A1A",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#0E2348",
      state: "#0E2348",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#D6E3FF",
      text: "#001B3F",
    },

    secondary: {
      background: "#D8E3F8",
      text: "#545F71",
    },

    info: {
      background: "#D6E3FF",
      text: "#1565C8",
    },

    success: {
      background: "#D7F0E0",
      text: "#1F8A56",
    },

    warning: {
      background: "#FFDDB3",
      text: "#8A5300",
    },

    error: {
      background: "#FFDAD6",
      text: "#BA1A1A",
    },

    light: {
      background: "#ffffff",
      text: "#D6E3FF",
    },

    dark: {
      background: "#0E2348",
      text: "#FFFFFF",
    },
  },

  coloredShadows: {
    primary: "#1565C8",
    secondary: "#545F71",
    info: "#1565C8",
    success: "#1F8A56",
    warning: "#E68A06",
    error: "#BA1A1A",
    light: "#D6E3FF",
    dark: "#0E2348",
  },

  inputBorderColor: "#d2d6da",
  surface: {
    lowest: "#FFFFFF",
    main: "#F8FAFD",
    container: "#ECF1F8",
    containerHighest: "#E0E7F0",
    variant: "#DFE3EC",
  },

  outline: {
    main: "#717C96",
    variant: "#C3CAD9",
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },

  popupHeader: {
    background: "#1565C8",
    text: "#FFFFFF"
  },

  brand: {
    primary: "#1565C8",
    primaryContainer: "#D6E3FF",
    onPrimaryContainer: "#001B3F",
    tertiary: "#8A5300",
    tertiaryContainer: "#FFDDB3",
    gold: "#E68A06",
    goldGradient: "linear-gradient(135deg, #FFD45C 0%, #FFB400 46%, #E68A06 100%)",
    orbGradient: "linear-gradient(135deg, #8FDBF4 0%, #193F8C 100%)",
    navy: "#0E2348",
  },
};

export default colors;
